import { CommonHttpOption } from "../../base/common-http-option";
import { CoreService } from "../../base/core";
import { Injectable, Output, EventEmitter } from "@angular/core";
import { ServiceRoute } from "../../base/service-route";
import { Observable } from "rxjs";
import { IGroup } from "src/app/interfaces/group";

@Injectable({
  providedIn: "root"
})
export class GroupService {
  constructor(private coreService: CoreService) {}

  @Output() change: EventEmitter<boolean> = new EventEmitter();
  @Output() hideDeatail: EventEmitter<boolean> = new EventEmitter();
  @Output() hideGpDet: EventEmitter<boolean> = new EventEmitter();

  list(page: number = 1, pageSize: number = 10): Observable<any> {
    return this.coreService.get(
      ServiceRoute.group.list,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }
  getById(id: number): Observable<any> {
    return this.coreService.get(
      ServiceRoute.group.getById + id,
      new CommonHttpOption().headers
    );
  }
  add(data: IGroup): Observable<any> {
    return this.coreService.post(
      ServiceRoute.group.add,
      data,
      new CommonHttpOption().headers
    );
  }
  edit(data: IGroup): Observable<any> {
    return this.coreService.put(
      ServiceRoute.group.edit,
      data,
      new CommonHttpOption().headers
    );
  }
  delete(data: any): Observable<any> {
    return this.coreService.delete(
      ServiceRoute.group.delete,
      new CommonHttpOption().headers,
      data
    );
  }

  fire() {
    this.change.emit();
  }

  hide() {
    this.hideDeatail.emit();
  }

  hideGpDetail() {
    this.hideGpDet.emit();
  }
}
